// extracted by mini-css-extract-plugin
module.exports = {"subscriptionCardsContainer":"styles-module__subscriptionCardsContainer___zTb5v"};